import React from 'react';
import { useSelector } from 'react-redux';

// eslint-disable-next-line no-shadow
function AddressCheck({ url }) {
  const store = useSelector(state => ({
    shopify: state.technical?.shopify,
    checkoutLookupData: state.personal?.checkoutLookupData,
    error: state.technical?.error,
    checkout: state.loanInfo?.checkout,
  }));

  const goBackToRetailor = () => {
    window.location.href = url;
  };

  const address2 = store.checkoutLookupData?.checkout_object?.customer?.billing?.address2
    ? `${store.checkoutLookupData?.checkout_object?.customer?.billing?.address2}, `
    : '';

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <h1 className="congratulation-header k-address-check-header">
          Looks like we have different information on record for you
        </h1>
        <p className="k-not-approved-text">Your shipping and billing addresses must match our records</p>
        <div className="k-address-check">
          <div className="k-address-check-element">
            <div className="k-address-check-title">You entered</div>
            <div className="k-address-check-desc">
              {`${store.checkoutLookupData?.checkout_object?.customer?.billing?.address}, `}
              {address2} {store.checkoutLookupData?.checkout_object?.customer?.billing?.city},{' '}
              {store.checkoutLookupData?.checkout_object?.customer?.billing?.state},{' '}
              {store.checkoutLookupData?.checkout_object?.customer?.billing?.zip}{' '}
            </div>
          </div>
          <div className="k-address-check-element">
            <div className="k-address-check-title k-address-check-pink">Must match</div>
            <div className="k-address-check-desc">
              {store.checkout?.address}, {store.checkout?.address2 ? ` ${store.checkout?.address2}, ` : ''}{' '}
              {`${store.checkout?.city}, ${store.checkout?.state}, ${store.checkout?.zip}`}
            </div>
          </div>
        </div>
        <div className="k-submit k-error-button k-not-approved-button">
          <button type="button" onClick={goBackToRetailor}>
            <strong>Back To Retailer</strong>
          </button>
        </div>
      </section>
    </div>
  );
}

export default AddressCheck;
